import {
  List,
  Datagrid,
  ReferenceField,
  NumberField,
  BooleanField,
  TextField,
  ReferenceInput,
  BooleanInput,
  TextInput,
  Edit,
  SimpleForm,
  Show,
  SimpleShowLayout,
} from 'react-admin'

// <Edit title={<PostTitle />}>
// const PostTitle = () => {
//   const record = useRecordContext()
//   return <span>Post {record ? `'${record.title}'` : ''}</span>
// }

export const UserUserReferralList = ({ isEdit, isDelete }) => (
  <List
    filters={[
      <TextInput source="invitedBy" label="Manual Invited By" />,
      <TextInput source="userId" label="Manual User ID" />,
      <BooleanInput source="isReferralClient" />,
      <ReferenceInput source="invitedBy" reference="users" />,
      <ReferenceInput source="userId" reference="users" />,
    ]}
  >
    <Datagrid bulkActionButtons={false} rowClick={isEdit ? 'edit' : 'show'}>
      <ReferenceField source="invitedBy" reference="users">
        <TextField source="walletAddress" />
      </ReferenceField>
      <ReferenceField source="userId" reference="users">
        <TextField source="walletAddress" />
      </ReferenceField>
      <TextField source="metadata" />
      <BooleanField source="isReferralClient" />
      <NumberField source="bonusInviterPoints" />
      <NumberField source="bonusInviteePoints" />
      <NumberField source="totalDepositPoints" />
      <NumberField source="dealsCount" />
    </Datagrid>
  </List>
)

export const UserUserReferralShow = () => (
  <Show>
    <SimpleShowLayout>
      <ReferenceField source="invitedBy" reference="users">
        <TextField source="walletAddress" />
      </ReferenceField>
      <ReferenceField source="userId" reference="users">
        <TextField source="walletAddress" />
      </ReferenceField>
      <TextField source="metadata" />
      <BooleanField source="isReferralClient" />
      <NumberField source="bonusInviterPoints" />
      <NumberField source="bonusInviteePoints" />
      <NumberField source="totalDepositPoints" />
      <NumberField source="dealsCount" />
    </SimpleShowLayout>
  </Show>
)
